import styled from "styled-components";
import { StatusFilterEnum } from "../../enums/StatusFilterEnum";
export const DocumentContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  border: 1px solid #e0e0e0;
  opacity: ${(props) => (props.status === StatusFilterEnum.ARCHIVED ? 0.7 : 1)};
  transition: all 0.2s ease-in-out;
  height: 170px;
  max-height: 185px;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const DocumentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const DocumentHeaderLeft = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 24px);
`;

export const DocumentHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ArchivedStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #666;
  font-size: 14px;
`;

export const DocumentContent = styled.div`
  color: #666;
  font-size: 14px;
  margin-bottom: 16px;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DocumentFooter = styled.div`
  display: flex;
  gap: 24px;
  font-size: 14px;
  border-top: 1px solid #e0e0e0;
  padding-top: 16px;

  > div {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const Title = styled.span`
  color: ${(props) => props.theme.colors.darkGray};
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Value = styled.span`
  color: #333;
  font-weight: 500;
  font-size: 12px;
  font-family: Inter;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`;
